import { render, staticRenderFns } from "./QutaProfit.vue?vue&type=template&id=2a5c595e&scoped=true&"
import script from "./QutaProfit.vue?vue&type=script&lang=js&"
export * from "./QutaProfit.vue?vue&type=script&lang=js&"
import style0 from "./QutaProfit.vue?vue&type=style&index=0&id=2a5c595e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c595e",
  null
  
)

export default component.exports